import { CHCUnderstandingMedicareChart } from './understanding-medicare-chart.component.js';

export { CHCUnderstandingMedicareChart };

customElements.define('chcapp-understanding-medicare-chart', CHCUnderstandingMedicareChart);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-understanding-medicare-chart': CHCUnderstandingMedicareChart;
  }
}
